import React from "react";
import "./ContentPanel.css";

export default function ContentPanel({
  children,
  as: Component = "section",
  padding = "md",
  variant = "default",
  className = "",
  ...props
}) {
  return (
    <Component
      className={[
        "content-panel",
        `content-panel--${variant}`,
        `content-panel--padding-${padding}`,
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      {...props}
    >
      {children}
    </Component>
  );
}
